import { render, staticRenderFns } from "./CreateProjectParticipant.vue?vue&type=template&id=386f65c8&scoped=true&"
import script from "./CreateProjectParticipant.vue?vue&type=script&lang=js&"
export * from "./CreateProjectParticipant.vue?vue&type=script&lang=js&"
import style0 from "./CreateProjectParticipant.vue?vue&type=style&index=0&id=386f65c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f65c8",
  null
  
)

export default component.exports